/*jshint esversion: 6 */

import $ from 'jquery';

function init() {
  let $body = $('body');
  let $mobileToggle = $('.page-navigation-toggle');
  let mobileToggleOpenClass = 'page-navigation-toggle--open';
  let bodyOpenClass = 'navigation-open';

  $('.page-overlay-navigation a').on('click', event => {
    $body.removeClass(bodyOpenClass);
    $mobileToggle
    .removeClass(mobileToggleOpenClass)
    .attr('aria-expanded', false);
  });

  $mobileToggle.on('click', () => {
    if ($mobileToggle.hasClass(mobileToggleOpenClass)) {
      $body.removeClass(bodyOpenClass);
      $mobileToggle
      .removeClass(mobileToggleOpenClass)
      .attr('aria-expanded', false);
    } else {
      $mobileToggle
      .addClass(mobileToggleOpenClass)
      .attr('aria-expanded', true);

      $body.addClass(bodyOpenClass);
    }
  });
}

export default init;